export const SIDEBAR = "SIDEBAR";